<template>
  <Modal v-model="completeAccountInfoModal" :title="$t('key1006175')" :transfer="false" :mask-closable="true" width="800"
    @on-visible-change="completeAccountInfoChange">
    <div class="flex mb24" :class="item.paramskey === 'remark' ? 'flex-direction' : 'align-items-center'" v-for="item in completeAccountInfolist">
      <span class="font-weight-bold color-333">{{ item.title }}</span>
      <span class="color-666">{{ item.paramsValue }}</span>
    </div>
    <template #footer>
      <Button type="primary" @click="completeAccountInfoModal = false">{{ $t('key1000732') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';

export default {
  name: 'completeAccountInfoModal',
  mixins: [Mixin],
  data() {
    return {
      completeAccountInfoModal: false,
      completeAccountInfolist: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001491'), paramskey: 'channel', paramsValue: ''},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001492'), paramskey: 'account', paramsValue: ''},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004613'), paramskey: 'currency', paramsValue: ''},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006174'), paramskey: 'remark', paramsValue: ''},
      ]
    };
  },
  methods: {
    // 初始化数据
    initCompleteAccountInfoData(obj) {
      this.completeAccountInfolist.map((item) => {
        item.paramsValue = obj[item.paramskey];
      });
      this.completeAccountInfoModal = true;
    },
    // 监听弹窗
    completeAccountInfoChange(value) {
      if (!value) {
        this.completeAccountInfolist.map((item) => {
          item.paramsValue = '';
        });
      }
    }
  }
};
</script>

<style lang="less">

</style>
